export default __webpack_public_path__ + "locales/lo-LA/SmartBanner.json?hash=2fef1b4b2d9b5172e43a99af833eb5bc";